export const apiSignature = {
  ADD_STAFF: "staff/addEmployee",
  FETCH_STAFF_LIST: "staff/fetchEmployeeData",
  UPDATE_STAFF: "staff/updateEmployee",
  ASSIGN_SERVICE_TO_STAFF: "staff/asignServiceToStaffApi",
  EMPLOYEE_SERVICE_RELATION_LIST: "fetchEmployeeServiceRelationData",
  UPDATE_STAFF_STATUS: "updateEmployeStatus",
  DELETE_SERVICE_STAFF: "deleteServiceStaffRelation",
  DELETE_STAFF: "staff/deleteEmployeeAPI",
  UPDATE_ATTENDENCE: "staff/updateAttendenceAPI",
  ADD_EMPLOYEE_SHIFT: "staff/addEmployeeShiftSchedule",
  DELETE_EMPLOYEE_SHIFT:'staff/deleteSheduleShift',
  ADD_COMMISSION:'staff/addCommission',
  GET_COMMISSION:'staff/fetchCommission',
  
};
